import React from "react"
import "@fontsource/roboto"
import "@fontsource/cormorant-garamond/500.css"
import "@fontsource/cormorant-garamond/600.css"

import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import LoadingScreen from "./src/components/LoadingScreen"

// サイト初回訪問時のみローディング演出を表示する
export const wrapRootElement = ({ element }) => (
  <LoadingScreen>{element}</LoadingScreen>
)